exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\r\n.bottom-space {\r\n    margin-bottom: 40px;\r\n}\r\n\r\n.no-bottom-space {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.statistics-close-btn {\r\n}\r\n\r\n.todo-close-btn {\r\n    margin: 0 10px -25px 0;\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\n.banner-close-btn {\r\n    margin: 0 10px -25px 0;\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\n.info-box {\r\n    cursor: pointer;\r\n    min-height: 50px;\r\n}\r\n\r\n    .info-box .info-box-icon {\r\n        height: 50px;\r\n        width: 50px;\r\n        font-size: 30px;\r\n        line-height: 50px;\r\n    }\r\n\r\n    .info-box .info-box-content {\r\n        margin-left: 50px;\r\n    }\r\n\r\n.red-info {\r\n    background: #152e2f;\r\n    color: #fff;\r\n    padding: 5px 15px;\r\n    text-transform: uppercase;\r\n    font-weight: 600;\r\n    font-size: 16px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/home/home.component.css
// module id = 707
// module chunks = 0